export enum StatusGetInstances {
  Initial = 'initial',
  Allocate = 'allocated',
  Running = 'running',
  Terminated = 'terminated',
  Failed = 'failed',
}

export const StatusGetInstancesLabel: Record<StatusGetInstances, string> = {
  [StatusGetInstances.Initial]: 'Initial',
  [StatusGetInstances.Allocate]: 'Allocate',
  [StatusGetInstances.Running]: 'Running',
  [StatusGetInstances.Terminated]: 'Terminated',
  [StatusGetInstances.Failed]: 'Failed',
};

export type CheckHuggingFaceSupportParams = {
  link: string;
  token?: string;
};
export type CheckHuggingFaceSupportRequest = {
  model_repo: string;
  model_token?: string;
};
export type CheckHuggingFaceSupportResponse = {
  code: string;
  model_architecture: 'Attention' | string;
  model_size_GB: number;
  min_vram_required_GB: number;
};

export enum CheckHuggingFaceSupportCode {
  AccessTokenInvalid = 'access token invalid',
  InvalidModelRepo = 'invalid model repo',
  ModelSizeTooLarge = 'model size too large',
  ModelArchitectureNotSupported = 'model architecture not supported',
  ModelRepoNotAuthenticated = 'model repo not authenticated',
  CanNotLoginWithHuggingFaceToken = 'can not login with huggingface token',
  ModelSupported = 'model supported',
}

export type SpecAndPricingInstanceGPU = {
  pricing_id: string;
  gpu_id: string;
  gpu_name: string;
  provider: string;
  region: string;
  priority: number;
  price: number;
  effective_date?: string;
  ineffective_date?: string;
  originalPrice?: number;
  discount?: number;
  vram: number;
  cuda_sm?: number;
  is_available: boolean;
};

export type GetAvailablePricingResponse = {
  code: string;
  pricing_info: SpecAndPricingInstanceGPU[];
};

export interface SpecAndPricingInstanceGPUWithDiscount
  extends SpecAndPricingInstanceGPU {
  isDiscounted: boolean;
  originalPrice: number;
  discount: number;
  // discountPercentage: number;
}

export enum ProviderInstance {
  AWS = 'aws',
  Float16 = 'float16',
  SiamAICloud='siam ai cloud',
}

export const ProviderInstanceLabel: Record<ProviderInstance, string> = {
  [ProviderInstance.AWS]: 'Amazon Web Services',
  [ProviderInstance.Float16]: 'Float16',
  [ProviderInstance.SiamAICloud]: 'Siam AI Cloud',
};

export const ProviderInstanceShortLabel: Record<ProviderInstance, string> = {
  [ProviderInstance.AWS]: 'AWS',
  [ProviderInstance.Float16]: 'Float16',
  [ProviderInstance.SiamAICloud]: 'Siam AI Cloud',
};

export const RegionInstanceLabel: Record<string, string> = {
  ["us-east-1"]: 'N. Virginia',
  ["us-west-2"]: 'Oregon',
  ["ap-northeast-1"]: 'Tokyo',
  ["ap-southeast-2"]: 'Sydney',
  ["ap-southeast-3"]: 'Jakarta',
};

export enum OptimizationTechnique {
  No = 'no',
  Basic = 'weight_8_only',
}

export const OptimizationTechniqueLabel: Record<OptimizationTechnique, string> =
  {
    [OptimizationTechnique.No]: 'No',
    [OptimizationTechnique.Basic]: 'Basic',
  };

export enum CreateDedicateInstancCode {
  SucceedRequestInstance = 'succeed request instance',
  CanNotRequestInstance = "can't request instance",
  InsufficientQuotaForRequestInstance = 'insufficient quota for request instance',
  InsufficientBalanceForRequestInstance = 'insufficient balance for request instance',
  InvalidPricingId = 'invalid pricing id',
  InsufficientResourceForRequestInstance = 'insufficient resource for request instance',
}

export type CreateDedicateInstanceRequest = {
  workspace_id: string;
  pricing_id: string;
  model_repo: string;
  model_token?: string;
  instance_name: string;
  optimize_technique: string;
  is_dry_run?: boolean;
};

export type CreateDedicateInstanceResponse = {
  instance_id: string;
  code: CreateDedicateInstancCode;
  workspace_id: string;
  created_at: string;
};

export type BaseInstanceInfo = {
  instance_id: string;
  instance_name: string;
  user_id: string;
  workspace_id: string;
  instance_type: string;
  model_repo: string;
  status: StatusGetInstances;
  created_at: string;
  updated_at: string;
};
export type InstanceSummary = BaseInstanceInfo;

export type InstanceInfo = {
  endpoint: string;
  api_key: string;
  batch_size: number;
  num_token: number;
  max_input_len: number;
} & BaseInstanceInfo &
  SpecAndPricingInstanceGPU;

export type GetInstancesRequest = {
  workspace_id: string;
};

export type GetInstancesResponse = {
  instances_info: BaseInstanceInfo[];
};

export type GetInstanceRequest = {
  workspace_id: string;
  instance_id: string;
};

export type GetInstanceResponse = InstanceInfo;

export type RegenerateAPIDedicateInstanceRequest = {
  instance_id: string;
};

export type RegenerateAPIDedicateInstanceResponse = {
  code: string;
  api_key: string;
};

export type DeleteDedicateInstanceRequest = {
  instance_id: string;
  is_dry_run?: boolean;
};

export type GetUsageAndCosDedicateInstanceByIdRequest = {
  instance_id: string;
};
export type GetUsageAndCosDedicateInstancesRequest = {
  start_date?: string;
  end_date?: string;
};

export type GetUsageAndCosDedicateInstance = {
  sum_price: number;
  items: Array<{
    instance_id: string;
    instance_name: string;
    gpu_name: string;
    compute_time: number;
    price: number;
    amount: number;
    isActive: boolean;
    start_time: string;
    end_time: string;
  }>;
};

export type GetDedicateInstanceAllWorkspace = Array<{
  instance_id: string;
  instance_name: string;
  number_of_gpu: number;
  created_at: string;
  workspace_id: string;
  workspace: {
    workspace_name: string;
  };
}>;

export type GetUsageLogsDedicateInstanceLLMRequest = {
  instance_id: string;
  start_date: string;
  end_date: string;
  time_unit: 'hour' | 'day' | 'week' | 'month';
};

export type UsageLogsDedicateInstanceLLM = {
  timestamp: string;
  count: number;
  total_prompt_usage: number;
  total_completion_usage: number;
  average_time_to_complete: number;
};

export type GetUsageLogsDedicateInstanceLLMResponse = {
  code: string;
  content: Array<UsageLogsDedicateInstanceLLM>;
};
